(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const update = (section) => {
    const media = section.querySelector('.gd-deals__bg');
    if (!media) return;

    if (reduceMotion.matches) {
      media.style.transform = 'translate3d(0, 0, 0) scale(1.12)';
      return;
    }

    const rect = section.getBoundingClientRect();
    const view = window.innerHeight || 1;
    // 0 when section enters bottom of viewport → 1 when it leaves the top
    const progress = (view - rect.top) / (view + rect.height);
    const clamped = Math.max(0, Math.min(1, progress));
    // Stronger reverse scroll so the BBQ plate feels almost fixed
    const shift = (0.5 - clamped) * 140;
    media.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0) scale(1.18)`;
  };

  // Subtle drift on a fixed full-viewport background (BBQ Box page)
  const updateFixedBg = (bg) => {
    const media = bg.querySelector('.gd-bbq-page-bg__image');
    if (!media) return;

    if (reduceMotion.matches) {
      media.style.transform = 'translate3d(0, 0, 0) scale(1.08)';
      return;
    }

    const maxScroll = Math.max(
      1,
      document.documentElement.scrollHeight - window.innerHeight
    );
    const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));
    // Gentle travel (~±28px) so the image stays mostly anchored
    const shift = (progress - 0.5) * 56;
    media.style.transform = `translate3d(0, ${shift.toFixed(2)}px, 0) scale(1.12)`;
  };

  const sections = () => document.querySelectorAll('[data-gd-deals-parallax]');
  const fixedBgs = () => document.querySelectorAll('[data-gd-bbq-bg-parallax]');

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      sections().forEach(update);
      fixedBgs().forEach(updateFixedBg);
      ticking = false;
    });
  };

  const init = () => {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    reduceMotion.addEventListener?.('change', onScroll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', onScroll);
})();
